import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService, NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  @Input() title = 'Confirm';
  @Input() body = 'Are you sure?';
  /** If set to '' we hide the button completely */
  @Input() cancel = 'Cancel';
  /** If set to '' we hide the button completely */
  @Input() confirm = 'Confirm';
  @Input() confirmClickDelay = 0;
  @Input() status?: 'basic' | 'primary' | 'info' | 'success' | 'warning' | 'danger' = 'primary';

  confirmLoading = false;

  constructor(
    private dialogService: NbDialogService,
    protected dialogRef: NbDialogRef<DialogComponent>,
  ) {}

  ngOnInit() {}

  cancelClicked() {
    this.dialogRef.close('cancel');
  }
  confirmClicked() {
    this.confirmLoading = true;
    setTimeout(() => {
      this.confirmLoading = false;
      this.dialogRef.close('confirm');
    }, this.confirmClickDelay);
  }
}
